module.exports = __webpack_public_path__ + "static/img5-f5098d53cff22f137e7bc0465b45cc83.png";